if (!customElements.get('segastore-collection-tabs')) {
  customElements.define('segastore-collection-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.tabs = Array.from(this.querySelectorAll('[data-edit-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-edit-panel]'));
      this.nav = this.querySelector('.segastore-collection-tabs__nav');
      if (!this.nav || !this.tabs.length || this.tabs.length !== this.panels.length) return;
      const pairsMatch = this.tabs.every((tab, index) => tab.getAttribute('href') === `#${this.panels[index].id}`);
      if (!pairsMatch) return;

      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.nav.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].tabIndex = 0;
      });

      this.nav.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-edit-tab]');
        if (!tab || !this.tabs.includes(tab) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.select(this.tabs.indexOf(tab), true);
      }, { signal });

      this.nav.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index === -1) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next;
        if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next !== undefined) {
          event.preventDefault();
          this.select(next, true);
        } else if (event.key === ' ') {
          event.preventDefault();
          this.select(index, true);
        }
      }, { signal });

      document.addEventListener('shopify:block:select', (event) => {
        const panel = this.panels.find((item) => item.dataset.blockId === event.detail?.blockId);
        if (panel) this.select(this.panels.indexOf(panel));
      }, { signal });

      window.addEventListener('hashchange', () => {
        const index = this.panels.findIndex((panel) => `#${panel.id}` === window.location.hash);
        if (index >= 0) this.select(index);
      }, { signal });

      const hashIndex = this.panels.findIndex((panel) => `#${panel.id}` === window.location.hash);
      this.select(hashIndex >= 0 ? hashIndex : 0);
      this.classList.add('is-enhanced');
    }

    select(index, focus = false) {
      this.tabs.forEach((tab, tabIndex) => {
        const active = index === tabIndex;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[tabIndex].hidden = !active;
      });
      if (focus) {
        this.tabs[index].focus({ preventScroll: true });
        this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.classList.remove('is-enhanced');
      this.nav?.removeAttribute('role');
      this.tabs?.forEach((tab) => {
        ['role', 'aria-controls', 'aria-selected', 'tabindex'].forEach((name) => tab.removeAttribute(name));
      });
      this.panels?.forEach((panel) => {
        panel.hidden = false;
        ['role', 'aria-labelledby', 'tabindex'].forEach((name) => panel.removeAttribute(name));
      });
    }
  });
}
